import type { AppDeveloperProfileShareCapability } from "@verbleif/lib/src/composables/Api/Type/AppStore/app.interface";

type Capability = AppDeveloperProfileShareCapability | null | undefined;

/**
 * What a developer profile share lets a colleague do on the organisation's apps. Mirrors the API's
 * `AppDeveloperProfileShareCapabilityEnum`, so the web app offers exactly what the API accepts.
 */
export const developerShare = {
  /** Edit the store listing: logo, introduction, description and support documentation URL. */
  allowsMarketing: (capability: Capability): boolean => capability != null && capability !== "logs_only",
  /** Read traffic logs, the activity feed and who installed the apps. */
  allowsLogs: (capability: Capability): boolean => capability != null && capability !== "marketing_design",
  /** Edit everything on an app that is neither the listing nor a secret. */
  allowsAppNonMarketingManage: (capability: Capability): boolean => capability === "full" || capability === "manage_without_credentials",
  /** Reveal, rotate or regenerate the apps' secrets. */
  allowsCredentials: (capability: Capability): boolean => capability === "full",
  /** Edit the developer profile's company fields. */
  allowsCompanyFieldEdit: (capability: Capability): boolean => capability != null && capability !== "logs_only",
  /** Add, change and remove other shares on the profile. */
  allowsShareAdmin: (capability: Capability): boolean => capability === "full",
  /** Submit an app for review or make it private. */
  allowsMakePrivateOrMarkReady: (capability: Capability): boolean => capability === "full",
};
